module.exports = __webpack_public_path__ + "img/prev-basic-b1.197393b4.webp";